<template>
<div>
	<!--<vue-form v-on:submit="saveNotes">

		<field :label="'Job #' + $store.project.job_num+' Notes'" 
			col-class="stacked"
			v-model="$store.project.notes"
			:params="{type:'richtext'}">
		</field>
	</vue-form>-->

	<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

	<div class="d-flex flex-row justify-content-between">
		<h2>
			Notes<br>
			<small>Project #{{$store.project.job_num}}, {{$store.project.job_name}}</small>
		</h2>

		<div class="d-flex align-items-center">

			<button class="btn btn-success mr-2" v-on:click="newNote">
				<i class="fa fa-plus"></i>
				New Note
			</button>

			<a class="btn btn-light mr-2" :href="'/project/'+this.$store.project.slug+'/notes/view'" target="_blank">
				<i class="fa fa-eye"></i>
				View All Notes
			</a>

			<!--
			<search-bar placeholder="Search Notes..." v-on:submit="searchNotes" v-on:clearSearch="fetchNotes"></search-bar>-->
		</div>
	</div>

	<section class="mt-2">

		<accordion v-for="(day,index) in daysWithNotes"
			:stay-open="index == 0"
			:heading="formatDate(day.date,'full-date') + '  (' + day.notesCount + ' notes)'"
			:key="'accordion_' + index"
			v-on:stateToggled="fetchNotesByDay(day.date)">

			<widget v-for="(note,noteIndex) in notesByDate[day.date]" 
			:title="note.subject ? note.subject : '(untitled)'"
			:key="'widget_' + noteIndex">

				<template slot="header">
					<div class="d-flex align-items-center">

						<i class="fa icon-button mt-2 mr-3 text-muted"
							 :class="!note.editMode ? 'fa-pencil-alt' : 'fa-times'"
							 v-on:click="headerButtonClick(note)"></i>

						<i v-if="!note.editMode"
							 class="fa fa-paper-plane icon-button mt-2 mr-3 text-muted"
							 v-on:click="openSendModal(note)"></i>

						<a v-if="!note.editMode" class="mt-2 mr-3 text-decoration-none"
							 :href="'/project/'+$store.project.slug+'/note/view/'+note.slug" target="_blank">
							<i class="fa fa-eye icon-button text-muted"></i>
						</a>

					</div>
				</template>

				<div class="inner-container">
					<div class="note-meta d-flex flex-row justify-content-between text-muted">
						<div>
							<template v-if="'UpdatedBy' in note && note.updated_at != note.created_at">
								Last updated by {{note.UpdatedBy.first_name}} {{note.UpdatedBy.last_name}} on {{formatDateTimeToLocal(note.updated_at)}}
							</template>
						</div>
						<div>
							<template v-if="'created_at' in note">
								Created {{formatDateTimeToLocal(note.created_at)}}
							</template>
							<template v-else-if="'id' in note">
								Created just now
							</template>
						</div>
					</div>

					<div v-if="!note.editMode" class="note-body mt-2" v-html="stripInlineEventHandlers(note.note)"></div>
					<vue-form v-else
						:no-top-button='true'
						:working="working"
						v-on:submit="saveNote(note,true)">

						<field label="Subject" 
							col-class="stacked"
							:params="{type:'text'}"
							v-model="payload.subject">
						</field>

						<field label="Note" 
							col-class="stacked"
							:params="{type:'richtext'}"
							v-model="payload.note"
							v-on:input="noteChange(note)">
						</field>

						<template slot="buttons-left">
							<button v-if="'id' in note" class="btn btn-outline-danger" type="button" v-on:click="deleteNote(note.id,day.date)">
								<i class="fa fa-trash"></i>
								Delete Note
							</button>
						</template>

					</vue-form>

					<template v-if="note.editMode || (note.UploadImage && note.UploadImage.length)">
						<hr>
						<div class="note-files">
							<h3>Images</h3>

							<upload-field v-if="note.editMode"
								style="width:100%;height: 40px;margin-top:10px"
								:icons="['fa-plus','fa-camera']"
								:multiple="true"
								accept="images"
								target="UploadImage/save"
								style-type="box"
								v-on:uploaded="imageUploaded($event,note,'id' in note)">
							</upload-field>

							<image-thumb-list :images="mutateAssetImages(note.UploadImage)"
								max-size="200px"
								v-on:rotate="rotateImage"
								v-on:deleteImg="deleteImage($event,note)">
							</image-thumb-list>

							<!--<file-list-item v-for="file in note.UploadFile"
								:key="file.id"
								:src="$store.apiRoot+'resources/files/'+$store.sessionToken+'/'+file.filename"
								:thumb-src="file.thumb_filename ? $store.apiRoot+'resources/images/'+$store.sessionToken+'/'+file.thumb_filename : false"
								:filename="file.original_filename"
								:size-kb="file.file_size_kb"
								:no-edit-button="true"
								:date-uploaded="file.created_at"
								:uploaded-by="file.UpdatedBy.first_name+' '+file.UpdatedBy.last_name"
								v-on:deleteFile="deleteFile(file,note)">
							</file-list-item>-->
						</div>
					</template>
				</div>
			</widget>
		</accordion>

		<send-document-modal
			document-type="Note"
			:visible="sendModal.isVisible"
			:customer="projectCustomer"
			:employees="$store.project.User"
			:value="sendModal.value"
			v-on:closeModal="sendModal.isVisible = false"
			v-on:send="sendNote">
		</send-document-modal>

		<p v-if="notesFullList.length == 0">No notes in the project yet</p>
	</section>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import VueForm from "@/components/VueForm"
import Widget from "@/components/Widget"
import UploadField from "@/components/UploadField"
import ImageThumbList from "@/components/ImageThumbList"
import SearchBar from "@/components/SearchBar"
import SendDocumentModal from "@/components/SendDocumentModal"
import Pagination from "@/components/Pagination"
import Accordion from "@/components/Accordion"
import Spinner from "@/components/Spinner"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"


export default {
	name: "ProjectNotes",
	components: {
		Field,
		VueForm,
		Widget,
		UploadField,
		SearchBar,
		ImageThumbList,
		SearchBar,
		SendDocumentModal,
		Pagination,
		Accordion,
		Spinner,
		FreemiumLockedAlert
	},
	data() {
		return {
			notes: [],
			notesByDate: {},
			notesFullList: [],
			projectCustomer: null,
			working: false,
			payload: {
				subject: "",
				note: "",
				UploadImage: [],
				editMode: false
			},
			sendModal: {
				note: {},
				isVisible: false,
				value: 0            // Updated after each modal change, resetting selected emails
			},
			newNoteImages: [], //list of ids of UploadFile model records that need to be updated with note_id
			noteImages: [],
			cacheBuster: 1,
			fetchingDailyNotes: false
		}
	},
	watch: {
		'$store.project'() {
			if ("id" in this.$store.project) {
				this.fetchNotes(false,true,true)
				this.fetchNotesByDay(this.moment().format("YYYY-MM-DD"))
			}
		}
	},
	computed: {
		daysWithNotes() {
			let days = [
				{
					date: this.moment().format("YYYY-MM-DD"),
					notesCount: 0
				}
			]
			let vm = this
			this.notesFullList.forEach(note => {
				let noteDate = vm.moment.utc(note.created_at)

				let foundIndex = days.findIndex(day => day.date == noteDate.format("YYYY-MM-DD"))
				if (foundIndex >= 0) {
					days[foundIndex].notesCount++
				}
				else {
					days.push({
						date: noteDate.format("YYYY-MM-DD"),
						notesCount: 1
					})
				}
			})

			return days
		},
	},	
	methods: {
		mutateAssetImages(images) {
			let vm = this

			if (images) {
				return images.map(image => {
					image.thumbUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.thumb_filename+"?v="+vm.cacheBuster
					image.fullUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.filename

					return image
				})
			}
			return []
		},
		renderHeaderButton(note) {
			if (this.payload.editMode) {
				if ("id" in note && "id" in this.payload && this.payload.id == note.id) 
					return 'fa-times'
				else
					return false
			}
			return 'fa-pencil-alt'
		},
		setFiles(note) {
			this.noteImages = this.primitize(this.cloneObj(note.UploadImage),"id")
		},
		newNote() {
			this.payload = {
				note: "",
				payload: "",
				editMode: true,
				UploadImage: []
			}
			this.newNoteImages = []
			this.noteImages = []

			//add blank one for new note
			let today = this.moment().format("YYYY-MM-DD")

			if (today in this.notesByDate) {
				this.notesByDate[today].unshift(this.payload)
			}
			else {
				this.notesByDate[today] = [
					this.payload
				]
			}


			this.$forceUpdate()
		},
		headerButtonClick(note) {
			if (!("id" in note)) { 
				//CANCEL new
				this.notes.shift()

				let newNote = this.notes.shift()
				let vm = this

				//delete uploaded images
				this.newNoteImages.forEach(id => {
					vm.postData("UploadImage/delete",{id: id})
				})
			}
			else if (note.editMode) {
				note.editMode = false
				this.payload = {}
			} else {
				//EDIT
				// Save previous note if exists
				//if ('editMode' in this.payload)
				//	this.saveNote(this.payload, true)
				this.payload = note
				note.editMode = true

				this.setFiles(note)
			}
			this.$forceUpdate()
		},
		noteChange(note) {
			if ("id" in this.payload) 
				this.debounce('saveNote',note,2000)
		},
		saveNote(note,closeEditMode) {
			let vm = this

			let payload = this.cloneObj(this.payload)

			payload.job_id = this.$store.project.id

			delete payload.UploadImage
			delete payload.editMode
			delete payload.payload

			this.working = true

			this.postData("JobNote/save",payload,true).then(response => {
				vm.working = false
				if (response.success) {

					if (closeEditMode)
						note.editMode = false

					vm.alertSaved("Note saved")

					if (!("slug" in vm.payload)) {
						note.slug = response.data.slug
						vm.payload.slug = note.slug
					}

					if (!("id" in vm.payload)) {
						note.id = response.data.record_id
						vm.payload.id = note.id

						vm.noteImages = vm.newNoteImages
						vm.syncFiles(response.data.record_id)
					}
				}
			})
		},
		imageUploaded(response,note,isOnExistingNote) {
			let vm = this

			this.setFiles(note)

			this.noteImages.push(response.data.id)

			if (isOnExistingNote) {
				this.syncFiles(note.id).then(response => {
					vm.fetchNoteImages(note)
				})
			}
			else {
				this.newNoteImages.push(response.data.id)

				let params = {
					include:[
						{
							model: "User",
							fields: ["id","first_name","last_name"]
						}
					]
				}

				this.getJSON("UploadImage/find/"+response.data.slug,params).then(response => {
					if (response.success) {
						note.UploadImage.push(response.data)
					}
				})
			}
			
		},
		deleteImage(image,note) {
			let vm = this

			let payload = {
				id: image.id
			}

			this.setFiles(note)

			this.postData("UploadImage/delete",payload,true).then(response => {

				vm.noteImages.splice(vm.noteImages.findIndex(id => note.id == id),1)

				vm.syncFiles(note.id).then(response => {
					vm.fetchNoteImages(note)
				})
			})
		},
		rotateImage(direction,image) {
			let vm = this

			let payload = {
				id: image.id,
				rotate_direction: direction
			}

			this.postData("UploadImage/rotate",payload).then(response => {
				vm.cacheBuster++
				//strip query string, and then add another random one
				vm.$forceUpdate()
			})
		},
		deleteNote(note_id,date) {
			let vm = this

			let payload = {
				id: note_id
			}

			this.postData("JobNote/delete",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Note deleted")
					vm.payload = {}
					vm.fetchNotesByDay(date)

					let noteIndexFullList = vm.notesFullList.findIndex(note => note.id == note_id)

					if (noteIndexFullList >= 0)
						vm.notesFullList.splice(noteIndexFullList,1)
				}
			})
		},
		syncFiles(note_id) {
			let vm = this

			let payload = {
				id: note_id,
				UploadImage: this.noteImages
			}

			return new Promise((resolve,reject) => {

				vm.postData("JobNote/save",payload).then(response => {
					resolve(response)
				})

			})
		},
		/*
		searchNotes(terms) {
			let vm = this

			let filters = [
				["subject",terms,"and","like"],
				["note",terms,"or","like"]
			]

			this.fetchNotes(filters)
		},
		*/
		openSendModal(note) {
			let vm = this

			this.sendModal.value += 1           // Reset selected emails
			this.sendModal.note = note          // Set selected note
			this.sendModal.isVisible = true     // Set visible

			//fetch project customer
			if (!vm.projectCustomer) {
				this.getJSON("Contact/find/" + this.$store.project.Customer.slug,{include:["Contact"]}).then(response => {
					if (response.success)
						vm.projectCustomer = response.data
				})
			}
		},
		sendNote(payload) {
			// Payload includes:
			//    additional - emails typed into modal
			//    employeeRecipients - user ids of employees
			//    recipients - user ids of subcontacts of customer

			let vm = this
			this.spinner(true)

			payload.note_id = vm.sendModal.note.id           // Used to build URL
			payload.userIdList = payload.employeeRecipients  // List of internal employee ids to email
			payload.contactIdList = payload.recipients       // List of customer subcontact ids to email

			// No longer needed
			delete payload.employeeRecipients
			delete payload.recipients

			this.postData("JobNote/send", payload).then(response => {
				vm.spinner(false)

				if (response.success) {

					vm.sendModal.isVisible = false
					vm.alertSuccess("Note #"+payload.note_id+" has been sent.")

					// Successful? Update file to be visible
					vm.sendModal.note.UploadFile.forEach(file => {

						file.sharing_on = 1
						vm.postData("UploadFile/update", file).then(fileResponse => {
							if (!fileResponse.success) {
								vm.alertErrors("Note #"+payload.note_id+" attachment could not be posted.")
							}
						})
					})

				} else {
					vm.alertErrors("Note #"+payload.note_id+" could not be sent.")
				}
			})
		},
		fetchNoteImages(note) {
			let vm = this

			let params = {
				include: [{model:"UploadImage",include:[
					{
						model: "User",
						fields: ["id","first_name","last_name"]
					}
				]}]
			}

			this.getJSON("JobNote/find/"+note.id,params).then(response => {
				if (response.success) {
					vm.payload.UploadImage = response.data.UploadImage
					note.UploadImage = response.data.UploadImage
				}
			})
		},
		fetchNotesByDay(date) {
			let filters = [
				["created_at >",date + " 00:00:00"],
				["created_at <=",date + " 23:59:59"],
				["job_id",this.$store.project.id]
			]

			this.fetchNotes(filters,false,date)
			this.fetchingDailyNotes = true
		},
		fetchNotes(filters,fullListBareBones = true, date = false) {
			let vm = this

			if (!filters) {
				filters = [
					["job_id",this.$store.project.id]
				]
			}

			let params = {
				orders: [
					["updated_at","desc"]
				],
				//page: this.page,
				filters
			}

			if (fullListBareBones) {
				params.fields = ["subject","created_at"]
			}
			else {
				params.include = [
					{
						model:"UploadImage",
						include:[
							{
								model: "User",
								fields: ["id","first_name","last_name"]
							}
						]
					},
					{
						model: "User",
						fields: ["id","first_name","last_name"]
					}
				]
			}

			this.spinner(true)

			this.getJSON("JobNote/get",params,true).then(response => {
				
				vm.spinner(false)
				
				vm.fetchingDailyNotes = false

				if (response.success) {
					if (fullListBareBones)
						vm.notesFullList = response.data
					else {
						vm.notesByDate[date] = response.data
					}

					vm.$forceUpdate()
					
					vm.numPages = response.meta.num_pages
				}
			})
		}
	},
	created() {
		if ("id" in this.$store.project) {
			this.fetchNotes(false,true)
			this.fetchNotesByDay(this.moment().format("YYYY-MM-DD"))
		}
	}
}
</script>

<style type="text/css" scoped>

	.icon-button {
		display: block;
		text-align: center;
	}
	.inner-container {
		padding: 10px;
	}

	.note-body {
		font-family: inherit;
		font-size: 14pt;
		color: #404040;
		margin: 0;
		word-wrap: break-word;
	}

	.note-files {
		margin-top: 10px;
	}

	.note-meta {
		font-size: 11pt;
		margin-top: -10px;
	}

	.note-meta span {
		font-size: 12pt;
	}
</style>